var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ui-select ng-model=\"vm.gameDeveloperName\" on-select=\"vm.updateCurrentGameDeveloper($select.selected)\" ng-required=\"true\" remove-selected=\"false\" ng-if=\"vm.showGameDevelopersDropdown\" class=\"c-select c-select--uiselect c-header-dropdown\"><ui-select-match placeholder=\"{{ 'select'|translate }}\">{{$select.selected['company_name']}}</ui-select-match><ui-select-choices repeat=\"option['company_name'] as option in vm.gameDevelopers | filter: $select.search | limitTo: 30\"><div ng-bind-html=\"option['company_name'] | highlight: $select.search\"></div></ui-select-choices></ui-select><div ng-if=\"!vm.showGameDevelopersDropdown\" class=\"header-title\">{{ vm.gameDeveloper.company_name }}</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/header/header-game-developers.jade
 ** module id = 578
 ** module chunks = 0
 **/